<template>
  <div>
    <oie-base-input-v2
      v-model="vatNumber"
      v-bind="$attrs"
      :label="$attrs.label ? $attrs.label : `${t('vatLabel')}`"
      :placeholder="$attrs.placeholder ? $attrs.placeholder : t('vatPlaceholder')"
      maxlength="18"
      :prefix="displayPrefix"
      :data-pw="playwright"
      v-on="$listeners"></oie-base-input-v2>
    <p v-if="verificationMessage" class="vat-input__verification-message">
      {{ verificationMessage }}
    </p>
  </div>
</template>

<script>
import utils from '@/core/utils'

export default {
  props: {
    countryCode: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Date],
      default: null
    },
    playwright: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      vatNumber: '',
      verificationMessage: ''
    }
  },
  computed: {
    displayPrefix() {
      return this.countryCode === 'AT' ? 'ATU' : this.countryCode
    }
  },
  watch: {
    vatNumber(newValue) {
      this.$emit('input', utils.saveVatNumberWithFormating(newValue, this.countryCode))
    },
    countryCode(newValue) {
      this.$emit('input', utils.saveVatNumberWithFormating(this.vatNumber, newValue))
    }
  },
  beforeMount() {
    if(this.value) {
      this.vatNumber = utils.extractVatNumberFromFormating(this.value, this.countryCode)
    }
  },
  mounted() {
    this.onVatUnavailable = event => { this.verificationMessage = event.detail || '' }
    this.onVatAvailable = () => { this.verificationMessage = '' }
    window.addEventListener('oie-vat-validation-unavailable', this.onVatUnavailable)
    window.addEventListener('oie-vat-validation-available', this.onVatAvailable)
  },
  beforeDestroy() {
    window.removeEventListener('oie-vat-validation-unavailable', this.onVatUnavailable)
    window.removeEventListener('oie-vat-validation-available', this.onVatAvailable)
  }

}
</script>

<style lang="scss">
.vat-input__verification-message { margin-top: .5rem; }
</style>
